import Vue from "vue";
import VueRouter from "vue-router";
import gtagjs from "vue-gtagjs";

// import Home from "./pages/Home";
import Garage from "@/pages/Garage";
import ElectricVehicle from "@/pages/ElectricVehicle";
import Detail from "@/pages/Garage/Detail";
import WhyBuyKLM from "@/pages/WhyBuyKLM";
import Brand from "@/pages/Brands";
import Kia from "@/pages/Kia";
import Audi from "@/pages/Audi";
import Volkswagen from "@/pages/Volkswagen";
import Bentley from "@/pages/Bentley";
import Zeekr from "@/pages/Zeekr";


// import ValuationService from "./pages/ValuationService";
import ValueYourCar from "@/pages/ValueYourCar";
import ContactUs from "@/pages/ContactUs";
import PrivacyPolicy from "@/pages/help/PrivacyPolicy";
// import TermsOfUse from "./pages/help/TermsOfUse";
// import DataProtectionNotice from "./pages/help/DataProtectionNotice";
// import Cookie from "./pages/help/Cookie";

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: "hash",
  mode: "history",
  // base: process.env.BASE_URL,
  base: '/',
  routes: [{
      path: "*",
      component: Garage
      // meta: {
      //     metaInfo: {
      //         title: "approvedplus.hk",
      //         keywords: "approvedplus.hk,audi,approvedplus,plus,hk,hkcar",
      //         description: "approvedplus.hk"
      //     }
      // }
    },
    // {
    //     path: "/",
    //     name: "Home",
    //     component: Home
    // },
    {
      path: "/",
      name: "Garage",
      component: Garage
    },
    {
      path: "/electricvehicle",
      name: "ElectricVehicle",
      component: ElectricVehicle
    },

    {
      path: "/valueyourcar",
      name: "ValueYourCar",
      component: ValueYourCar
    },
    {
      path: "/garage/:id",
      name: "Detail",
      component: Detail
    },
    {
      path: "/WhyBuyKLM",
      name: "WhyBuyKLM",
      component: WhyBuyKLM
    },
    {
      path: "/brand",
      name: "Brand",
      component: Brand
    },
    {
      path: "/kia",
      name: "KIA",
      component: Kia
    },
    {
      path: "/audi",
      name: "AUDI",
      component: Audi
    },
    {
      path: "/volkswagen",
      name: "VOLKSWAGEN",
      component: Volkswagen
    },
    {
      path: "/bentley",
      name: "BENTLEY",
      component: Bentley
    },
    {
      path: "/zeekr",
      name: "ZEKKR",
      component: Zeekr
    },
    {
      path: "/:brand_/garage/:id",
      name: "Detail",
      component: Detail
    },
    // {
    //     path: "/valuemycar",
    //     name: "ValuationService",
    //     component: ValuationService
    // },
    {
      path: "/contactus",
      name: "ContactUs",
      component: ContactUs
    },
    {
      path: "/privacypolicy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy
    }
    // {
    //     path: "/termsofuse",
    //     name: "TtermsOfUse",
    //     component: TermsOfUse
    // },
    // {
    //     path: "/dataprotectionnotice",
    //     name: "DataProtectionNotice",
    //     component: DataProtectionNotice
    // },

    // {
    //     path: "/cookie",
    //     name: "Cookie",
    //     component: Cookie
    // }
  ]
});

gtagjs(router, "UA-177778805-1", {
  debug: true,
  scriptId: "gtagjs"
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

router.afterEach(() => {
  // 滚动到顶部
  // window.scrollTo(0, 0);

  // 若需要平滑滚动，可添加行为参数（IE 不支持）
  window.scrollTo({ top: 0, behavior: 'smooth' });
});
export default router;



// WEBPACK FOOTER //
// ./src/router.js